import React from "react";
import { Image, Modal, Tabs} from "antd";
import {CloseCircleOutlined} from "@ant-design/icons";
import useFetch from "hooks/fetch";
import Card from "./card";

const Main : React.FC = () => {

    const [isLoading, datasource] = useFetch("project", "desc");

    /**
     *
     * @param img
     * @param title
     * @param desc
     */
    const openModal = (img : string, title : string, desc : string) : void => {
        Modal.info({
            title         : null,
            icon          : null,
            width         : 500,
            closable      : true,
            centered      : false,
            closeIcon     : <CloseCircleOutlined style={{fontSize : 20, color : "#ffffff"}} />,
            okButtonProps : {style : { display : "none"}},
            style         : {padding : 0, overflow : "hidden"},
            bodyStyle     : {padding : 0},
            content       : (
                <div>
                    <Image
                        width={"100%"}
                        src={img}
                        alt={title}
                        style={{ marginTop : "-8px", borderRadius : "5px 5px 0 0", cursor: "pointer"}}
                    />
                    <div style={{padding : "23px 20px"}}>
                        <h3 style={{fontWeight : "bold"}}>{title}</h3>
                        <p>{desc}</p>
                    </div>
                </div>
            )
        })
    }

    return (
        <section className={"main-list"}>
            <div className={"public-container"}>
                <Tabs defaultActiveKey="1" centered={true}>
                    <Tabs.TabPane tab={"Semua"} key={1}>
                        <Card isLoading={isLoading} datasource={datasource} openModal={openModal} filter={"Semua"} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"Website"} key={2}>
                        <Card isLoading={isLoading} datasource={datasource} openModal={openModal} filter={"Website"} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"Mobile"} key={3}>
                        <Card isLoading={isLoading} datasource={datasource} openModal={openModal} filter={"Mobile"} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"Event"} key={4}>
                        <Card isLoading={isLoading} datasource={datasource} openModal={openModal} filter={"Event"} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"Sisfo"} key={5}>
                        <Card isLoading={isLoading} datasource={datasource} openModal={openModal} filter={"Sisfo"} />
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </section>
    )
}

export default React.memo(Main);